<ng-ut-results-grid
  *ngIf="(store$ | async) as store"
  [gridConfigs]="gridConfigs"
  [filtersConfigs]="filtersConfigs"
  [filtersExtraConfigs]="filtersExtraConfigs"
  [data]="data"
  [loading]="store.loading"
  [type]="type"
  [releaseDate]="store.releaseEmptiesDate"
  [releaseEmptiesHeader]="store.releaseEmptiesHeader"
  [emptyPermits]="store.emptyPermits"
  [trainConsist]="store.trainConsist"
  [gridInitialized]="gridInitialized"
  (search)="makeAdvanceSearch($event)"
  (next)="confirmationStep($event)"
  (releaseCars)="releaseCars($event)">
</ng-ut-results-grid>
